import getApiClient from '@/plugins/api-client'

export default {
    loadEvent: function () {
        const self = this,
            eventId = self.$route.params.id,
            api = getApiClient(self.$store)

        api.get(`/events/${eventId}`)
            .then(result => {
                if (result.data.order && !result.data.order?.taxes) {
                    result.data.order.taxes = []
                }
                self.event = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },

    getStatusBadge(status) {
        switch (status) {
            case 0:
                return 'info';
            case 1:
                return 'success';
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                return 'danger';
        }
    },

    getJobTypeLabel(type) {
        return this.jobTypes.filter(item => {
            return item.code === type
        })[0]?.label
    },

    setEventStatus(status) {
        this.event.order.status = status
    },

    updateEventStatus() {
        const self = this,
            api = getApiClient(self.$store)

        if (self.event.order.status === 'cancelled') {
            api.patch(`/events/${self.event.id}`, {
                status: self.event.order.status
            }, {
                headers: {
                    'Content-Type': 'application/merge-patch+json'
                }
            })
              .then(() => {
                  self.loadEvent()
              })
              .catch(error => {
                  console.log(error)
              })
        }

        api.patch(`/orders/${self.event.order.id}`, {
            status: self.event.order.status
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {})
            .catch(error => {
                console.log(error)
            })
    },

    updateJobStatus(status, job) {
        const self = this,
          api = getApiClient(self.$store)

        if (status === null) {
            return
        }

        api.patch(`/jobs/${job.id}`, {
            status
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
          .then(() => {
              this.loadEvent()
          })
          .catch(error => {
              console.log(error)
          })
    },

    sendOrderConfirmation() {
        const self = this,
          api = getApiClient(self.$store)

        api.post(`/events/${self.event.id}/resend_order_confirmation`, {})
          .then(() => {
              this.showConfirmationModal = true
          })
          .catch(error => {
              console.log(error)
          })
    },

    closeConfirmationModal() {
        this.showConfirmationModal = false
    },

    closeCategoryUpdatedModal() {
      this.showCategoryUpdatedModal = false
    },

    setEventCategory(category) {
      const self = this,
        api = getApiClient(self.$store)

      this.event.category = category

      api.patch(`/events/${self.event.id}/update_category`, {
        category
      }, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      })
        .then(() => {
          self.showCategoryUpdatedModal = true
        })
        .catch(error => {
          console.log(error)
        })

    },
}
